import { useEffect, useRef, useState, type KeyboardEvent } from "react";

interface ChatBarProps {
  onSubmit?: (message: string) => void;
  onVoice?: () => void;
  onLiveCall?: () => void;
  placeholder?: string;
}

export function ChatBar({
  onSubmit,
  onVoice,
  onLiveCall,
  placeholder = "Ask · open a deal · run lender match · show stats · type or speak...",
}: ChatBarProps) {
  const [value, setValue] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  // Focus on mount — covers the new-cockpit and the navigation case (FocusView
  // mounts its own ChatBar after `navigate`). Until the user clicks out, the
  // chat box stays the keyboard target across responses + view switches.
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const submit = () => {
    const trimmed = value.trim();
    if (!trimmed) return;
    onSubmit?.(trimmed);
    setValue("");
    // Keep focus on the input after submit so the user can keep chatting.
    inputRef.current?.focus();
  };

  const onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  };

  return (
    <div className="chat-bar">
      <div className="chat-prompt">EDGE</div>
      <input
        ref={inputRef}
        className="chat-input"
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
      />
      <div className="chat-controls">
        <button className="chat-btn" title="Voice command" onClick={onVoice}>
          🎙
        </button>
        <button
          className="chat-btn live-call"
          title="Start live call recording"
          onClick={onLiveCall}
        >
          REC
        </button>
      </div>
    </div>
  );
}
